import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'
import { otherValue } from '../shared/constants/general-enums/value-other'

export const uiSchema: UiSchema = {
    item_number: {
        'ui:placeholder': 'Select Bracket Type',
    },
    item_number_other: {
        'ui:placeholder': 'Bracket Other Type',
    },
}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    const newSettings = { ...settings, ...formData }

    if (newSettings.item_number.toLowerCase() === otherValue) {
        newSettings.item_number = newSettings.item_number_other
    }
    newSettings.item_number_other = null

    return newSettings
}

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
